import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP8NrOvw202604: FaireAdPerformancePeriodEntity = {
  token: "perf_p8_nr_ovw_202604",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-04-01",
  endDate: "2026-04-30",
  impressions: 119420,
  clicks: 1911,
  adsSpendDollars: 11749,
  budgetDollars: 15000,
  salesDollars: 79856,
  bestEstimateRoas: 6.8,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.78,
  newCustomersAcquired: 47,
  reorderConversions: 207,
  dataAvailableAtDate: "2026-05-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
